<section class="main-section">
    <header *ngIf="(userRole.includes(rolesMaster.SchoolAdmin) || userRole.includes(rolesMaster.MatAdmin)) && !createSchool" class="d-flex justify-content-between align-items-center main-heading">
      <div class="d-flex align-items-center">
        <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
          role="button" aria-controls="offcanvasExample">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          </svg></a>
        <h3 [ngClass]="schoolName ? 'visited-heading-span cursor-pointer underline': ''" class="heading-span" (click)="schoolName=''; schoolUsers = []; schoolId = 0">
          <span>{{ "School Details" }}</span>
        </h3>
        <h3 *ngIf="schoolName" class="heading-span"> / {{schoolName}} </h3> 
      </div>
      <div class="d-flex pe-0">
        <div class="col-md-2 text-end">
          <button type="button" class="btn theme-btn" (click)="schoolId ? openCreateSchoolUserDialog() : createSchool = true">Create School {{ schoolId ? " User" : "" }}</button>
        </div>
      </div>
    </header>
    <div *ngIf="!createSchool">
      <ng-container *ngIf="schoolUsers.length == 0; else schoolUserList">
        <div *ngIf="schoolData?.length" class="table-responsive tab-table school-detail-table px-3 mb-0"
        [ngClass]="{'school-detail-admintable': userRole.includes(rolesMaster.MatAdmin)}">
          <table
          aria-describedby="This table describes the users information"
          class="table table-hover"
          >
          <thead>
            <tr>
              <th>S.No</th>
              <th>School Name</th>
              <th>School Code</th>
              <th *ngIf="userRole.includes(roleMaster.SuperAdmin) || userRole.includes(roleMaster.AccountAdmin)">School Reference</th>
              <th>Location</th>
              <th>School Capacity</th>
              <th>Headcount</th>
              <th>No of School Users</th>
              <th>Teaching Staff</th>
              <th>Non-Teaching Staff</th>
              <th>School Type</th>
              <th>Curriculum</th>
              <th>Address</th>
              <th>Local Authority</th>
              <th>ID: URN/DfE Number/UKPRN</th>
              <th class="action-header">Comment</th>
              <th class="action-header">Document</th>
              <th class="action-header sticky-right">Action</th>

            </tr>
          </thead>
          <tbody class="tbody-userlists">
            <tr *ngFor="let school of schoolData; index as i" class="cursor-pointer" (click)="goToSchoolUsers(school)">
              <td>{{i + 1}}</td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" 
                [matTooltip]="school.schoolName!">
                <a class="text-decoration-underline text-grey-e" (click)="goToSchoolUsers(school)"> {{school.schoolName}} </a>
              </p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.id">{{school.id}}</p>
              </td>
              <td *ngIf="userRole.includes(roleMaster.SuperAdmin) || userRole.includes(roleMaster.AccountAdmin)">
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.myReferenceSchoolCode!">{{school.myReferenceSchoolCode}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.location!">{{school.location}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.schoolCapacity}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.headcountOfSchool}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.numberOfSchoolUser}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.numberOfNonTeachingStaff}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.numberOfTeachingStaff}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.schoolType!">{{school.schoolType}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.curriculum!">{{school.curriculum}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.address!">{{school.address}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.localAuthority!">{{school.localAuthority}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.schoolRegistrationId}}</p>
              </td>
              <td>
                <span class="cursor-pointer">
                  <svg
                  (click)="$event.preventDefault();$event.stopPropagation();openCommentModal(school.notes!)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z"
                      stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path opacity="0.4"
                      d="M22.0003 12.8603C22.0003 15.1503 20.8203 17.1803 19.0003 18.4603L17.6603 21.4103C17.3503 22.0803 16.4503 22.2103 15.9803 21.6403L14.5003 19.8603C12.0803 19.8603 9.92031 18.7903 8.57031 17.1203L9.50031 16.0003C13.6403 16.0003 17.0003 12.8703 17.0003 9.00031C17.0003 7.95031 16.7503 6.96031 16.3003 6.07031C19.5703 6.82031 22.0003 9.58029 22.0003 12.8603Z"
                      stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
              </td>
              <td class="text-center">
                <a class="cursor-pointer">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  ViewDocument(school)">
                    <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#4F6681"
                      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M7 13H13" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7 17H11" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </td>
              <td class="sticky-right">
                <ng-container>
                  <a class="btn-action" (click)="$event.preventDefault();$event.stopPropagation();editSchool(school)" matTooltip="Edit details">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                        stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M9.90845 4.20837C10.2668 6.50837 12.1334 8.26671 14.4501 8.50004" stroke="#4F6681"
                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M2.5 18.3334H17.5" stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </a>
                  <a class="btn-action" (click)="$event.preventDefault();$event.stopPropagation();deleteSchool(school)" matTooltip="Delete details">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z"
                        fill="#4F6681" />
                    </svg>
                  </a>
                </ng-container>
              </td>
              
            </tr>
          </tbody>
          </table>
        </div>
        <div *ngIf="!schoolData?.length" class="noDataFound">
          <h1>{{'No Data Found'}}</h1>
        </div>
      </ng-container>
      <ng-template #schoolUserList>
        <app-user-details [viewMode]="true" [schoolUserList]="schoolUsers" [openedFromIndividualSchool]="true" [showSchoolUser] = "showSchoolUser"
          [roles]="roles" (actionEmitter)="actionTriggered($event)" [packageId]="packageId"
          [schoolId]="schoolId" [clientAccountId]="clientAccountId">
        </app-user-details>
      </ng-template>
    </div>
    <div *ngIf="createSchool">
      <app-create-school (hideHeader)="createSchool=$event" (schoolCreated)="getSchoolDetails(clientAccountId)" [clientAccountId]="clientAccountId" [packageToAssign]="packageId"></app-create-school>
    </div>
  </section>
  